import { Injectable } from '@angular/core';
import { MapProvider } from './map-provider.service';
import { GoogleMapsProviderService } from './google-maps-provider.service';
import { OpenStreetMapProviderService } from './openstreetmap-provider.service';
import { MapKitService } from '../mapkit.service';

export type MapProviderType = 'GOOGLEMAP' | 'OPENROUTESERVICE' | 'MAPKIT';

@Injectable({
  providedIn: 'root'
})
export class MapFactoryService {
  constructor(
    private googleMapsProvider: GoogleMapsProviderService,
    private openStreetMapProvider: OpenStreetMapProviderService,
    private mapKitProvider: MapKitService
  ) {}

  getMapProvider(type: MapProviderType): MapProvider {
    switch (type) {
      case 'GOOGLEMAP':
        return this.googleMapsProvider;
      case 'OPENROUTESERVICE':
        return this.openStreetMapProvider;
      case 'MAPKIT':
        return this.mapKitProvider;
      default:
        throw new Error(`Unsupported map provider type: ${type}`);
    }
  }

  isGoogleMaps(type: MapProviderType): boolean {
    return type === 'GOOGLEMAP';
  }

  isOpenStreetMap(type: MapProviderType): boolean {
    return type === 'OPENROUTESERVICE';
  }

  isMapKit(type: MapProviderType): boolean {
    return type === 'MAPKIT';
  }
} 